import { RegularTableRow } from "./RegularTableRow";
import { getFeeLowLevel } from "./ShowHideUtils";

export function fakeInvestments(resp) {
    let fakeNum = 0;
    if (resp._embedded) {
        // event withdrawal payments details -> investments
        resp._embedded.transactionEventResourceList
            .filter(trev => trev.paymentDetails && trev.paymentDetails.type === "WTHR")
            .forEach(trev => {
                const id = trev.trevId + "-fake-" + fakeNum;
                const mapping = {
                    TRX_HIGH_LEVEL: "Withdrawals",
                    TRX_LOW_LEVEL: "Actual payment details"
                };
                const narrative = `Paid to bank account ${RegularTableRow.formatSort(
                    trev.paymentDetails.bankSortCode
                )} / ${trev.paymentDetails.bankAccountNumber}`;

                const fakeInvest = createFake(
                    trev.paymentDetails.effectiveDate,
                    id,
                    mapping,
                    narrative,
                    [],
                    trev.paymentDetails.amount
                );
                trev.accountTransactions[0].investmentTransactions.push(fakeInvest);
                fakeNum++;
            });

        // event fees -> investments
        resp._embedded.transactionEventResourceList
            .filter(trev => trev.trevFees.length > 0)
            .forEach(trev => {
                trev.trevFees.forEach(fee => {
                    const id = trev.trevId + "-fake-" + fakeNum;
                    const mapping = {
                        TRX_HIGH_LEVEL: "Fees and charges",
                        TRX_LOW_LEVEL: getFeeLowLevel(fee.xptpShortDescription)
                    };
                    const itrnFees = [fee.dtrnDeductionAmount * -1];
                    const fakeInvest = createFake(
                        trev.trevEffectiveDate,
                        id,
                        mapping,
                        fee.xptpShortDescription,
                        itrnFees,
                        null
                    );
                    trev.accountTransactions[0].investmentTransactions.push(fakeInvest);
                    fakeNum++;
                });
            });
    }
    return resp;
}

function createFake(
    itrnEffectiveDate,
    itrnId,
    itrnMappings,
    itrnTtypDescription,
    itrnFees,
    itrnEffectiveAmount
) {
    return {
        dishonour: false,
        itrnEffectiveDate,
        itrnId,
        itrnMappings,
        itrnPriceApplied: 0,
        itrnTtypDescription,
        itrnEffectiveAmount,
        orderStatus: "Settled",
        reversal: false,
        xordExpCashSettlementDate: null,
        itrnFees,
        fund: {},
        fake: true
    };
}
